export default __webpack_public_path__ + "static/media/Cookie-policies-tdsa-02.30383472.jpg";